// extracted by mini-css-extract-plugin
module.exports = {"root":"Category_root__3Jb25","label":"Category_label__275No","content":"Category_content__3Cfne","header":"Category_header__3Lh7_","location":"Category_location__1a8Eh"};